<template>
    <button class="db-btn-outline sm default primary transparent modal-btn m-0.5">
        <i class="lab lab-line-edit"></i>
        <span class="db-tooltip">{{ $t('button.edit') }}</span>
    </button>
</template>

<script>
export default {
    name: "SmModalEditComponent",
}
</script>

<style scoped>

</style>
